import { gql } from "@apollo/client";
import moment from "moment";

export const GET_PACIENTES = gql`
query GetPacientes($estado: String!, $idDelegacion: Int!) {
    allPacientesFromContrato(estado: $estado, idDelegacion: $idDelegacion)
    {
          success,
            error,
            valorEsperado {
                idPaciente,
                nombre,
                apellido,
                mail,
                codSAPPaciente,
                fechaNacimiento,
                sinDoc,
                sexo,
                idTipoDocumento,
                numeroDocumento,
                familiar,
                familiarTelefono,
                telefonoContacto,
                idEstadoPaciente
            }
    }
}`;

export const adaptPaciente = (paciente) => {
  return {
    idPaciente: paciente.idPaciente,
    nombre: paciente.nombre,
    apellido: paciente.apellido,
    mail: paciente.mail,
    codSAPPaciente: paciente.codSAPPaciente,
    fechaNacimiento: moment(paciente.fechaNacimiento).format("yyyy-MM-DD"),
    sinDoc: paciente.sinDoc,
    sexo: paciente.sexo,
    idTipoDocumento: paciente.idTipoDocumento,
    numeroDocumento: paciente.numeroDocumento,
    familiar: paciente.familiar,
    familiarTelefono: paciente.familiarTelefono,
    telefonoContacto: paciente.telefonoContacto,
    idEstadoPaciente: paciente.idEstadoPaciente
  };
};

export const adaptPacientesArray = (
pacientes) =>
{
  return structuredClone(pacientes?.allPacientesFromContrato?.valorEsperado)?.
  map((paciente) => adaptPaciente(paciente));
};